import { defaultApplicationSettings } from '../store/applicationSettingsDefinitions';
import { ApplicationSettings } from '../store/schema/ApplicationSettings';
import type { ApplicationSettingsConfig } from '../store/schema/ApplicationSettingsConfig';
import store from '../store/store';
import {
    generateApplicationSettingsReport,
    getNoSettingsReport,
} from '../utils/generateApplicationSettingsReport';

export default function initializeApplicationSettings(config?: ApplicationSettingsConfig) {
    store.initialized = true;

    if (!config) {
        store.report = getNoSettingsReport();
        return;
    }

    if (!config.settings) {
        store.lastError = config.lastError;
        store.report = getNoSettingsReport();
        return;
    }

    const mergedSettings: { [key: string]: any } = {};

    const defaultGroups = Object.keys(
        defaultApplicationSettings
    ) as (keyof typeof defaultApplicationSettings)[];

    defaultGroups.forEach(group => {
        mergedSettings[group] = {};
        const receivedGroup = config.settings[group];

        const defaultAppSettingGroup = defaultApplicationSettings[group];
        const defaultSettingKeys = Object.keys(
            defaultAppSettingGroup
        ) as (keyof typeof defaultAppSettingGroup)[];

        defaultSettingKeys.forEach(setting => {
            mergedSettings[group][setting] =
                receivedGroup && receivedGroup.hasOwnProperty(setting)
                    ? receivedGroup[setting as keyof typeof receivedGroup]
                    : defaultApplicationSettings[group][setting];
        });
    });

    store.configIDs = config.configIDs;
    store.lastError = config.lastError;
    store.settings = mergedSettings as ApplicationSettings;
    store.report = generateApplicationSettingsReport(
        defaultApplicationSettings,
        config.settings,
        config.lastError
    );
}
